import { Component } from 'react';
import ImageTransformer from "./ImageTransformer";
import * as Constants from "../helper/Constants";
import SupabaseClientWrapper from "./SupabaseClientWrapper";
import UrlHelper from "./UrlHelper";
import {customDataProvider} from "../admin/customDataProvider";

const supabase = SupabaseClientWrapper.create();
const dataProvider = customDataProvider;


class ProjectDatabase extends Component {
    static getCategories = async (categoryUrlId=null) => {
        let params = {
            pagination: { page: 1, perPage: 100 },
            sort: { field: 'rank', order: 'ASC' },
        };
        if (categoryUrlId) {
            params["filter"] = {url_id: categoryUrlId}
        }

        return dataProvider.getList("Category", params);
    }

    static getCategory = async (categoryUrlId) => {
        return ProjectDatabase.getCategories(categoryUrlId);
    }

    static getAllProjectCategories = async () => {
        return ProjectDatabase.getCategories();
    }

    static getProjectFromId = async (id) => {
        if (id) {
            return dataProvider.getOne("Project", {
                id
            });
        }
    }

    static getProjects = async (ids=null, specific_url_id=null) => {
        if (ids) {
            return dataProvider.getMany("Project", {
                ids
            });
        }

        let params = {
            pagination: { page: 1, perPage: 100 },
            sort: { field: 'titel', order: 'ASC' },
        };
        if (specific_url_id) {
            params["filter"] = {url_id: specific_url_id}
        }
        return dataProvider.getList("Project", params)
    }

    static getAllProjects = async (inAscendingOrder = false) => {
        return ProjectDatabase.getProjects();
    };

    static getProjectsWithIds = async (ids) => {
        return ProjectDatabase.getProjects(ids);
    }

    static getPicturesForProject = async (projectId) => {
        return dataProvider.getList("Picture", {
            pagination: { page: 1, perPage: 100 },
            sort: { field: 'sort_order', order: 'ASC' },
            filter: { project_id: projectId }
        });
    }

    static getProject = async (projectUrlId) => {
        const response = await ProjectDatabase.getProjects(null, projectUrlId);
        if (!response.data || response.data.length === 0) {
            return response;
        }
        const project = response.data[0];
        const picturesResponse = await ProjectDatabase.getPicturesForProject(project.id);
        const pictures = (picturesResponse.data || [])
            .filter(p => p.s3_url)
            .map(p => ({ s3_url: p.s3_url, description: p.description || null }));
        return {
            ...response,
            data: [{ ...project, pictures }]
        };
    }

    static getProjectsOfCategory = async (categoryUrlId) => {
        let data = await ProjectDatabase
            .getCategory(categoryUrlId)
            .then(response => {
                if (response.data.length > 0) {
                    return ProjectDatabase.getProjectsWithIds(response.data[0].projectIds)
                } else {
                    return { data: null, error: `No category with url_id ${categoryUrlId}` };
                }
            });
        return data;
    }

    static getFirstPicturePerProject = async () => {
        return dataProvider.getList("Picture", {
            pagination: { page: 1, perPage: 500 },
            sort: { field: 'project_id', order: 'ASC' },
            filter: { sort_order: 0 }
        });
    }

    static getAllStartPictures = async () => {
        return dataProvider.getList("Picture", {
            pagination: { page: 1, perPage: 1000 },
            sort: { field: 'project_id', order: 'ASC' },
            filter: { sort_order: 0 }
        });
    }

    static getStartPageProjects = async () => {
        return dataProvider.getList("Project", {
            pagination: { page: 1, perPage: 100 },
            sort: { field: 'sort_order', order: 'ASC' },
            filter: {isOnStartpage: true}
        });
    }

    static getContactinformation = async () => {
        return dataProvider.getList("Contactinformation", {
            pagination: { page: 1, perPage: 100 },
            sort: { field: 'street', order: 'ASC' },
        })
    }

    static checkIfImageWithSameAlreadyExists = (imageFile) => {
        return ProjectDatabase.getImagePublicUrl(UrlHelper.join("public/", imageFile.path));
    }

    static getImagesOfPublicDirectory = async () => {
        const result = await supabase
            .storage
            .from('project-images')
            .list('public', {
                limit: 100,
                offset: 0,
                sortBy: { column: 'name', order: 'asc' },
            })
        return result;
    }

    static uploadImage = async (imageFile) => {
        const result = await supabase
            .storage
            .from('project-images')
            .upload('public/' + imageFile.path, imageFile, {
                cacheControl: '31536000',
                upsert: false
            })
            .then((response) => {
                    if (response.data !== null) {
                        let publicUrl = ProjectDatabase.getImagePublicUrl(response.data.Key.replace("project-images/", "")).publicURL;
                        return { data: publicUrl, error: null}
                    }
                    if (response.error !== null ) {
                        return { data: null, error: response.error}
                    }
                }
            );
        return result
    }

    static deleteImages = async (imagesUrls) => {
        if (imagesUrls.length < 1){
            return
        }

        const folderPaths = imagesUrls.map(url => {
            let splitted = url.split("/");
            return splitted[splitted.length - 2] + "/" + splitted[splitted.length - 1]
        })

        const { data, error } = await supabase
            .storage
            .from('project-images')
            .remove(folderPaths)
        console.log("removed images");

        return await supabase
            .storage
            .from('project-images')
            .remove(folderPaths)
    }

    static getImagePublicUrl = (imagePath) => {
        const result = supabase
            .storage
            .from('project-images')
            .getPublicUrl(imagePath)
        return result;
    }


    static getImageUrlWithoutParams(fullImageUrl) {
        if (!fullImageUrl.includes("?")) {
            return fullImageUrl;
        }
        let split = fullImageUrl.split("?");
        return split[0];
    }

    static getProjectsWithProjectCategory = () => {
        //TODO
        // let allProjects = [];
        // for (let projectCategory of projects.default) {
        //     for (let project of projectCategory.projects) {
        //         allProjects.push({projectCategory, ...project})
        //     }
        // }
        //
        // allProjects.sort((project1, project2) => project2.jahr - project1.jahr);
        //
        // return allProjects;
    }

    static getThumbnail = (imagePath) => {
        return ProjectDatabase.getImageFromPublicFolder(imagePath);
    }

    static getImageFromPublicFolder = (imagePath) => {
       return process.env.PUBLIC_URL + imagePath;
   }

   static getLinkForCategory = (category) => {
       return `${Constants.LINK_HOME}${Constants.LINK_ALL_CATEGORIES_RELATIVE}/${category.url_id}`;
   }
}

export default ProjectDatabase;
